import { Routes } from '@angular/router';

import { ROUTE_NAMES } from '@constants';
import { AuthReverseGuard } from 'src/app/core/guards/auth-reverse.guard';
import {
  i18nResolver,
  userBeanResolver,
  userBeanWithPermissionCheckResolver,
} from 'src/app/core/resolvers';
import { groupResolver } from './resolvers/group.resolver';
import { groupsResolver } from './resolvers/groups.resolver';
import { loginResolver } from './resolvers/login.resolver';
import { userResolver } from './resolvers/user.resolver';
import { usersResolver } from './resolvers/users.resolver';

export const accountRoutes: Routes = [
  {
    path: 'users',
    title: 'WEB_USER_LIST',
    resolve: {
      resource: usersResolver,
      userBean: userBeanResolver,
      agorai18n: i18nResolver,
    },
    loadComponent: () =>
      import('./pages/users.component').then((m) => m.UsersComponent),
    data: { navigationRoute: ROUTE_NAMES.USERS },
  },
  {
    path: 'users/:id',
    title: 'WEB_USER_AAA',
    pathMatch: 'full',
    resolve: {
      resource: userResolver,
      userBean: userBeanResolver,
      agorai18n: i18nResolver,
    },
    loadComponent: () =>
      import('./pages/user.component').then((m) => m.UserComponent),
    data: { navigationRoute: ROUTE_NAMES.USERS },
  },
  {
    path: 'groups',
    title: 'WEB_GROUP_LIST',
    resolve: {
      resource: groupsResolver,
      agorai18n: i18nResolver,
      userBean: userBeanWithPermissionCheckResolver,
    },
    loadComponent: () =>
      import('./pages/groups.component').then((m) => m.GroupsComponent),
    data: { navigationRoute: ROUTE_NAMES.GROUPS },
  },
  {
    path: 'groups/:id',
    title: 'WEB_GROUP_AAA',
    pathMatch: 'full',
    resolve: {
      group: groupResolver,
      agorai18n: i18nResolver,
      userBean: userBeanResolver,
    },
    loadComponent: () =>
      import('./pages/group.component').then((m) => m.GroupComponent),
    data: { navigationRoute: ROUTE_NAMES.GROUPS },
  },
  {
    path: 'login',
    canActivate: [AuthReverseGuard],
    resolve: {
      appData: loginResolver,
    },
    loadComponent: () =>
      import('./pages/login.component').then((m) => m.LoginComponent),
    data: { navigationRoute: ROUTE_NAMES.LOGIN },
  },
  {
    path: 'registration',
    title: 'WEB_REGISTATION_AAA',
    resolve: {
      agorai18n: i18nResolver,
    },
    loadComponent: () =>
      import('./pages/registration.component').then(
        (m) => m.RegistrationComponent
      ),
    data: { navigationRoute: ROUTE_NAMES.REGISTRATION },
  },
  {
    path: 'activation',
    title: 'WEB_REGISTATION_ACTIVATION',
    resolve: {
      agorai18n: i18nResolver,
    },
    loadComponent: () =>
      import('./pages/activation.component').then((m) => m.ActivationComponent),
    data: { navigationRoute: ROUTE_NAMES.ACTIVATION },
  },
];
